import { render, staticRenderFns } from "./TradingTestFailedBySq.vue?vue&type=template&id=4514a494"
import script from "./TradingTestFailedBySq.vue?vue&type=script&lang=ts"
export * from "./TradingTestFailedBySq.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports